// 'http://admisionapi.uniq.edu.pe/public/api'
// export const baseUrlAPI = "https://admisionapi.uniq.edu.pe/public/api";
export const baseUrlAPI = process.env.VUE_APP_ENDPOINT_URL
// export const baseUrlAPI = "http://localhost:18830/public/api";
